import { Outlet } from 'react-router-dom';

import Logo from '@lib/core/src/assets/logo/journey-logo-black.svg?react';
import palette from '@lib/core/src/theme/palette';
import { Stack, styled } from '@mui/material';

export const MainContainer = styled(Stack)({
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  background: palette.common.background.grey
});

export const Frame = styled(Stack)({
  flexDirection: 'row',
  justifyContent: 'space-between',
  height: '100%',
  width: '100%'
});

const JourneyLogo = styled(Logo)({
  width: '84px',
  height: '40px',
  position: 'absolute',
  right: '50%',
  transform: 'translateX(50%)',
  top: '40px'
});

const PageContainer = styled(Stack)({
  width: '100%',
  height: '100%',
  paddingTop: '32px',
  justifyContent: 'center',
  alignItems: 'center'
});

const ExtensionLoginFlowLayout = () => (
  <MainContainer>
    <Frame>
      <JourneyLogo />
      <PageContainer>
        <Outlet />
      </PageContainer>
    </Frame>
  </MainContainer>
);

export default ExtensionLoginFlowLayout;
